<div class="m-t-20">
  <div class="heading-tab">
    <h3 class="heading"><i nz-icon nzType="file-text"></i> {{'Bank Details' | MMSTranslate}}</h3>
  </div>  <h3 id="payerId" class="heading" style="margin-bottom: 0px">Bank Details of {{this.bankBeneficiaryRole}}</h3>
  <nz-tabset [nzSize]="'large'">
    <ng-container *ngFor="let data of payeeList; let payeeIndex=index; ">
      <ng-template #titleTmplBankNominee>
        <strong class="d-b">Payer {{payeeIndex+1}}: {{data?.clientDO[0]?.firstName}}
          {{data?.clientDO[0]?.lastName}}</strong>
        <p class="col-green m-b-5">
          Bank details added
        </p>
      </ng-template>
      <nz-tab [nzTitle]="titleTmplBankNominee">
        <div class="text-a-right">
          <button nz-button nzType="primary" (click)="addNewBankForm()">Add Bank</button>
        </div>
        <div class="card-container">
          <nz-tabset nzType="card" [nzSelectedIndex]="enableSpecificBankTab">
            <nz-tab *ngFor="let bankData of bankDataList; let indx = index;" [nzTitle]="'Bank '+ (indx+1)">
              <div class="m-b-20" style="width:400px;">
                <form [formGroup]="multiBankDetailsForm">
                  <nz-form-item>
                    <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('clientTypeCd')">Purpose</nz-form-label>
                      <nz-select formControlName="purpose" nzShowSearch nzAllowClear nzMode="multiple" nzPlaceHolder="Select Purpose" [(ngModel)]="bankDataList[indx]['bankFormPurpose']" (ngModelChange)="updateBankPurpose($event,indx)" nzShowArrow>
                        <nz-option *ngFor="let item of (lookup$.AccountPurpose | async) as purposeCd; trackBy:item?.lookupKey"
                          [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                      </nz-select>
                      <nz-form-explain
                        *ngIf="(multiBankDetailsForm.get('purpose').dirty || multiBankDetailsForm.get('purpose').touched) && multiBankDetailsForm.get('purpose').errors">
                        <p style="color:red"
                          *ngFor="let error of validationUtilService.getUIErrorList(multiBankDetailsForm.get('purpose'),'multiBankDetailsForm')">
                          {{error.errorMessage || '' |translate}}</p>
                    </nz-form-explain>
                  </nz-form-item >
                </form>
              </div>
              <bank-details [inputDataForEdit]="data" [smartUIConfig]="smartUIConfig"
                (componentOutput)="_BaseEmitHandler($event, data['clientDO']? data['clientDO'][0]['clientNum'] : null)" [entityGuid]="guid">
              </bank-details>
            </nz-tab>
          </nz-tabset>
        </div>
      </nz-tab>
    </ng-container>
  </nz-tabset>
  <app-generic-zero-ui [list]="payeeList" icon="file-search" [title]="multiCaptureBankDetails['title']"
    [message]="multiCaptureBankDetails['message']"></app-generic-zero-ui>
</div>